'use strict';

module.exports = ['$uibModalInstance', 'BuilderDataService', 'element', 'isForValidator', '$translate', '$sce', 'dialog', function ($uibModalInstance, BuilderDataService, element, isForValidator, $translate, $sce, dialog) {
    var _this = this;
    _this.element = element;
    _this.isForValidator = isForValidator;
    _this.form = BuilderDataService.getForm();

    this.validOperations = ["=", "!=", "<", ">", "<=", ">=", "existe", "!existe"];
    this.removeBlock = function (scope) {
        scope.remove();
    };

    this.removeCondition = function (index) {
        _this.element.dynamicRequires.splice(index, 1);
    };
    this.addCondition = function (conditions) {
        if (_this.element.dynamicRequires) {
            _this.element.dynamicRequires.push({
                conditions: [
                    {
                        type: "field",
                        fieldId: "",
                        value: "",
                        operator: "" //>,< ,>= >=, !=
                    }
                ],
                options: []
            });
        } else {
            _this.element.dynamicRequires = [
                {
                    conditions: [
                        {
                            type: "field",
                            fieldId: "",
                            value: "",
                            operator: "" //>,< ,>= >=, !=
                        }
                    ],
                    options: []
                }
            ];
        }
    };

    this.addBlock = function (operator, list) {
        switch (operator) {
            case "or":
                list.push({
                    type: "operator",
                    operator: "or",
                    rules: []
                });
                break;
            case "and":
                list.push({
                    type: "operator",
                    operator: "and",
                    rules: []
                });
                break;
            case "field":
                list.push({
                    type: "field",
                    fieldId: "",
                    value: "",
                    operator: "" //>,< ,>= >=, !=
                });
                break;
            default:
                break;
        }
    };

    this.areValid = function (conditions) {
        let invalid = conditions.filter(function (con) {
            return !con.valid;
        });

        if (invalid && invalid.length > 0) {
            return false;
        } else {
            return true;
        }
    };

    this.close = function () {
        if (_this.element.dynamicRequires?.length > 0) {
            // If all the fields of the condition are empty, the condition will be removed
            _this.element.dynamicRequires.forEach(element => {
                element.conditions = element.conditions.filter(function(condition) {
                    return !((condition.fieldId === undefined || condition.fieldId === '') && (condition.operator === undefined|| condition.operator === '') && (condition.value === undefined || condition.value === ''));
                });
            });
            _this.element.dynamicRequires = _this.element.dynamicRequires.filter(function(element) {
                return element.conditions.length > 0;
            });

            if (_this.areValid(_this.element.dynamicRequires)) {
                _this.$close(_this.element);
            } else {
                this.errorMessage(
                    $translate.instant("DASHBOARD.DASH_BUILDER.ERROR_CONDITIONS.TITLE"),
                    // "Error: Campos incompletos",
                    $translate.instant("DASHBOARD.DASH_BUILDER.ERROR_CONDITIONS.MESSAGE")
                    // "Debe completar todos los campos de cada condición."
                );
            }
        } else {
            _this.$close(_this.element);
        }
    };

    this.errorMessage = function (title, error) {
        dialog.alert({
            title: title,
            body: $sce.trustAsHtml(error),
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: "md",
            html: true,
        });
    };
}]